import gql from 'graphql-tag'
import { UserFieldsFragment } from '../user/user'

export { SchoolWithDirectorFields as ISchoolWithDirector } from './__generated__/SchoolWithDirectorFields'

export const SchoolWithDirectorFieldsFragment = gql`
  fragment SchoolWithDirectorFields on School {
    director {
      ...UserFields
    }
  }

  ${UserFieldsFragment}
`
